export enum WizardStep {
    Upload,
    Record,
    Main,
    Loading,
    Success,
    VerificationError,
    LimitError,
}
